module.exports = __webpack_public_path__ + "static/media/yoga-graphic.3f5c1e61.svg";